import produce from "immer";
import * as types from "../types";

const initialState = {
  clientes: [],
  clientesExportar: [],
  cliente: {},
  isLoading: false,
  error: null,
  page: 1,
  pageSize: 25,
  pageMax: false,
  dataBuscar: {},
  showModal: false,
  editMode: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CLIENTES:
    case types.GET_CLIENTES_EXPORTAR:
    case types.GET_CLIENTE:
    case types.CREATE_CLIENTE:
    case types.UPDATE_CLIENTE:
    case types.DELETE_CLIENTE:
      return produce(state, (draft) => {
        draft.isLoading = true;
      });
    case types.GET_CLIENTES_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.clientes = action.payload.clientes;
        draft.pageMax = action.payload.next === null;
        draft.error = null;
        draft.dataBuscar = action.payload.dataBuscar
          ? action.payload.dataBuscar
          : {};
        if (action.payload.buscando) draft.page = 1;
      });
    case types.CLIENTES_NEXT_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page + 1;
      });
    case types.CLIENTES_PREV_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page - 1;
      });
    case types.CLIENTES_CHANGE_PAGE_SIZE:
      return produce(state, (draft) => {
        draft.page = 1;
        draft.pageSize = action.payload;
      });
    case types.CLIENTES_SHOW_MODAL:
      return produce(state, (draft) => {
        draft.showModal = true;
      });
    case types.CLIENTES_HIDE_MODAL:
      return produce(state, (draft) => {
        draft.showModal = false;
        draft.editMode = false;
        draft.cliente = {};
        draft.error = null;
      });
    case types.CREATE_CLIENTE_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.showModal = false;
      });
    case types.GET_CLIENTE_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = true;
        draft.showModal = true;
        draft.cliente = action.payload;
      });
    case types.UPDATE_CLIENTE_SUCCESS:
    case types.DELETE_CLIENTE_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = false;
        draft.cliente = {};
        draft.showModal = false;
      });
    case types.CLIENTES_ERROR:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = action.payload ? action.payload : "offline";
      });
    case types.CLIENTES_SET_EXPORTANDO:
      return produce(state, (draft) => {
        draft.exportando = action.payload;
      });
    case types.GET_CLIENTES_EXPORTAR_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        // draft.showModal = false;
        draft.clientesExportar = action.payload.clientesExportar;
        draft.error = null;
        draft.exportando = true;
      });
    default:
      return state;
  }
};
